<template>
<FocusBackground :src="''">
    <div id="home">
        <RequestSigninModal ref="signinModal" @confirm="onSigninRequestConfirm" @error="onSigninError"></RequestSigninModal>
        <MessageModal ref="messageModal" title='Kolkin Sign In' message="Please check your email for the sign-in link."></MessageModal>
		<MessageModal ref="errorMessageModal" title='Kolkin Sign In' message="This email is not linked to your investor account."></MessageModal>
        <main>
            <section>
                <h1>Investor Relations</h1>

                <button v-if="user.is_investor == 't'" @click="$router.push({name: 'account'})">View Account</button>
                <button v-else @click="requestSignin">Sign-in</button>
            </section>
        </main>
    </div>
</FocusBackground>
</template>

<script>
import {
    mapGetters
} from "vuex";
import store from "@/store"
import RequestSigninModal from "@/components/navbar/RequestSigninModal";
import MessageModal from "@/../submodules/vue-base/components/MessageModal";

import FocusBackground from "@/../submodules/vue-base/components/FocusBackground";
export default {

    name: "home",

    components: {
        RequestSigninModal,
		MessageModal,
        FocusBackground
    },

    data() {
        return {

        }
    },

    methods: {

        requestSignin() {
            this.$refs.signinModal.open();
        },
        onSigninRequestConfirm() {
            this.$refs.messageModal.open();
        },
		onSigninError(){
			this.$refs.errorMessageModal.open();
		}

    },

    computed: {

        userSessionEmpty() {
            return this.user && Object.keys(this.user).length === 0 && this.user.constructor === Object
        },

        ...mapGetters(['user'])

    },

};
</script>
